import { createSlice } from "@reduxjs/toolkit";
import { allTenantAction } from "../../actions/TenantAction/tenantAction";

const tenant = {
  data: [],
  loading: true,
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState: tenant,
  reducers: {},
    extraReducers: (builder) =>
    builder
    .addCase(allTenantAction.pending, (state, action) => {
        state.loading = true;
      })
    .addCase(allTenantAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        return state;
      })
    .addCase(allTenantAction.rejected, (state, action) => {
        state.loading = false;
      }),
});

export default tenantSlice.reducer;
